// extracted by mini-css-extract-plugin
export default {"slide":"hero_slide__d6xvZ","h1":"hero_h1__KBLv5"};